// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"159b9983","149":"d326c6c1","225":"2d591e94","291":"bfdb4563","333":"f087ce7c","389":"b05fc75d","687":"257baf00","761":"36e61e73","795":"82c9ed53","842":"52cd1b22","884":"d10ce89d","946":"3b629a37","972":"ade6cbf1","997":"90f76a1f"}[chunkId] + ".chunk.js";
};